import { getSpacing, SpacingName, ThemedFunctor } from '@doveit/bricks';
import { css } from 'styled-components';

export const wrapper: ThemedFunctor = ({ theme }) => css`
  min-width: 15rem;
  padding: ${theme.remSize[150]};
`;

export const coveredGeoDashedLine: ThemedFunctor = ({ theme }) => css`
  ${getSpacing.margin(theme, [0, SpacingName.SMALLER, 0])};
  border: none;
  border-top: 1px dashed ${theme.palettes.neutrals.light};
  flex-grow: 1;
`;
